import React from "react"
import { NumericFormat } from "react-number-format"
import { format } from "date-fns"
import { downloadInvoicePDF } from "../utils/pdfDownload"

const InvoiceComponent = ({ Invoice, Colour }) => {
  console.log(Invoice, "INVOICE COMPONENT")

  const handleDownload = () => {
    downloadInvoicePDF(Invoice, Colour)
  }

  return (
    <div className="w-full py-2">
      <div className="flex justify-end mb-2">
        <button
          onClick={handleDownload}
          className="px-4 py-2 text-white text-sm font-semibold rounded hover:opacity-90 transition-opacity"
          style={{ backgroundColor: Colour }}
        >
          Download PDF
        </button>
      </div>
      <div className="flex flex-col md:flex-row  md:justify-between px-1 border-b border-gray-200 pb-4">
        <div className="text-left">
          {Invoice?.vendor?.vendor_settings?.logo ? (
            <img
              src={Invoice.vendor.vendor_settings.logo}
              alt={Invoice?.vendor?.vendor_name}
              className="w-32 h-32 my-3 object-contain"
              onError={e => {
                // e.target.onerror = null;
                e.target.style.display = "none"
                e.target.nextSibling.style.display = "inline"
              }}
            />
          ) : null}
          <p className="text-xl py-1 font-bold" style={{ color: Colour }} display="none">
            {Invoice?.vendor?.vendor_name}
          </p>
          <p className="text-base text-sm">
            {Invoice?.vendor?.email && (
              <>
                {Invoice.vendor.email}
                <br />
              </>
            )}
            {Invoice?.vendor?.phone &&
              (Invoice.vendor.phone.startsWith("+234")
                ? Invoice.vendor.phone
                : `+234 (0) ${Invoice.vendor.phone}`)}
          </p>
        </div>
        <div className="text-right">
          <p className="font-bold text-xl py-1" style={{ color: Colour }}>
            BILL TO
          </p>
          <p className="text-base text-sm mt-2">
            {Invoice?.grn?.stores?.map((store, index) => (
              <span key={index}>
                <b>
                  {store.store_name} ({store.byd_cost_center_code})
                </b>
                <br />
                {store.store_email}
                {index < Invoice.grn.stores.length - 1 && <br />}
              </span>
            ))}
          </p>
        </div>
      </div>
      <div className="w-full px-1 mt-4">
        <div>
          <div
            className="border-2 font-normal text-[#545454] flex flex-col"
            style={{ borderColor: Colour }}
          >
            <div className="flex px-2 py-1 m-0">
              <span>
                <b>Invoice Date:</b>
              </span>
              <span className="text-right flex-grow ">
                {format(new Date(Invoice?.date_created), "dd-MMM-yyyy")}
              </span>
            </div>
            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>PO Number:</b>
              </span>
              <span className="flex-grow text-right">{Invoice?.grn?.purchase_order?.po_id}</span>
            </div>
            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>GRN Number:</b>
              </span>
              <span className="flex-grow text-right">{Invoice?.grn?.grn_number}</span>
            </div>
            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>External Reference:</b>
              </span>
              <span className="flex-grow text-right">{Invoice?.external_document_id}</span>
            </div>

            <div className="mt-2 border-t border-gray-200 pt-2"></div>

            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>Total (minus Tax):</b>
              </span>
              <span className="flex-grow text-right">
                ₦
                <NumericFormat
                  value={Invoice.net_total}
                  displayType="text"
                  thousandSeparator={true}
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                />
              </span>
            </div>
            <div className="flex gap-36 m-0 px-2 py-1">
              <span>
                <b>Tax Amount:</b>
              </span>
              <span className="flex-grow text-right">
                ₦
                <NumericFormat
                  value={Invoice.total_tax_amount}
                  displayType="text"
                  thousandSeparator={true}
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                />
              </span>
            </div>
            <hr className="border-gray-200" />
            <div className="flex gap-36 m-0 p-2 text-lg">
              <span>
                <b>Total (incl. Tax):</b>
              </span>
              <span className="flex-grow text-right">
                ₦
                <NumericFormat
                  value={Invoice.gross_total}
                  displayType="text"
                  thousandSeparator={true}
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="w-full mt-4 border-gray-200 table-auto">
          <thead className="text-white text-xs w-full" style={{ backgroundColor: Colour }}>
            <tr className="text-center">
              <td className="font-semibold px-1 py-3 whitespace-nowrap">SN</td>
              <td className="font-semibold px-2 whitespace-nowrap">Description</td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Unit Price
                <br />
                (₦)
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Ordered
                <br />
                Quantity
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Delivered
                <br />
                Quantity
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">Discount</td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Gross Total
                <br />
                (₦)
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Tax
                <br />
                (₦)
              </td>
              <td className="font-semibold px-1 whitespace-nowrap">
                Net Total
                <br />
                (₦)
              </td>
            </tr>
          </thead>
          <tbody>
            {Invoice.invoice_line_items.map((item, index) => (
              <tr key={index} className="border-b dark:border-gray-700 text-xs text-center">
                <td className="py-2 px-1">{index + 1}</td>
                <td className="px-2 text-left min-w-[120px]">
                  {item.grn_line_item.purchase_order_line_item.product_name}
                </td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item.purchase_order_line_item.unit_price}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
                <td className="px-1 whitespace-nowrap">
                  <NumericFormat
                    value={item.grn_line_item.purchase_order_line_item.quantity}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                  <br />
                  <span className="text-[10px] text-gray-400">
                    {item.grn_line_item.purchase_order_line_item.unit_of_measurement}s
                  </span>
                </td>
                <td className="px-1 whitespace-nowrap">
                  <NumericFormat
                    value={item.quantity}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                  <br />
                  <span className="text-[10px] text-gray-400">
                    {item.grn_line_item.purchase_order_line_item.unit_of_measurement}s
                  </span>
                </td>
                <td className="px-1">{item.discount ? item.discount : 0.0}</td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.gross_total}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.tax_amount}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
                <td className="px-1 text-right whitespace-nowrap">
                  <NumericFormat
                    value={item.net_total}
                    displayType="text"
                    thousandSeparator={true}
                    decimalSeparator="."
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex w-full px-4 items-center">
        <div className=" w-full mt-8 text-[#545454]">
          <div>
            <p className="text-center text-lg signature border-b border-gray-200 pb-2 font-bold">
              {Invoice?.vendor?.vendor_name
                .split(" ")
                .map(name => name[0])
                .join(".")}
            </p>
            <p className="text-center text-sm my-2">Vendor's Initials</p>
            <p className="text-center text-sm my-2">
              Created On {format(new Date(Invoice?.due_date), "dd-MM-yyyy")}
            </p>
          </div>
        </div>

        <div className="w-full mt-8 text-[#545454]">
          <div className="text-right" style={{ color: Colour }}>
            Total (minus Tax): ₦
            <NumericFormat
              value={Invoice.net_total}
              displayType="text"
              thousandSeparator={true}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
            />
          </div>
          <div className="text-right mt-2" style={{ color: Colour }}>
            Tax Amount: ₦
            <NumericFormat
              value={Invoice.total_tax_amount}
              displayType="text"
              thousandSeparator={true}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
            />
          </div>
          {/* {discountincluded &&
          <div className="text-right mt-2" style={{ color: Colour }}>
              Discount: ₦
          <NumericFormat value={Invoice.total_discount_amount} displayType="text" thousandSeparator={true} decimalSeparator="." decimalScale={2} fixedDecimalScale />
        </div>
          } */}
          <div className="text-right mt-2 font-bold text-lg" style={{ color: Colour }}>
            Total (Incl. Tax): ₦
            <NumericFormat
              value={Invoice.gross_total}
              displayType="text"
              thousandSeparator={true}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceComponent
